import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { doHideSnackbar } from "../../../actions/ui";
import { getSnackbarState } from "../../../selectors/ui";

import "./index.scss";

const Snackbar = props => {
  const { text, type, isVisible, onCloseSnackbar } = props;

  const boxClasses = classNames({
    snackbar__box: true,
    [`snackbar__box--${type}`]: true,
    "snackbar__box--closed": !isVisible,
  });

  return (
    <div className={boxClasses}>
      <div className="snackbar__text">{text}</div>
      <button
        className="snackbar__close"
        type="button"
        aria-label="Close"
        onClick={onCloseSnackbar}
      />
    </div>
  );
};

Snackbar.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onCloseSnackbar: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...getSnackbarState(state),
});

const mapDispatchToProps = {
  onCloseSnackbar: doHideSnackbar,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Snackbar);
